import { useEffect, useState } from 'react';
import { clientConfig } from '../config/clientConfig';
import { hubspot } from '../utils/hubspot';

type CookiebotWindow = Window & { Cookiebot?: { consented: boolean } };

const isCookiebotConsented = (): boolean => {
  const cookiebot = (window as CookiebotWindow).Cookiebot;
  return cookiebot?.consented !== false;
};

export default function HubspotScript() {
  const [shouldLoad, setShouldLoad] = useState(false);

  useEffect(() => {
    if (!clientConfig.isHubspotEnabled) {
      return;
    }

    const checkAndLoad = () => {
      if (isCookiebotConsented()) {
        setShouldLoad(true);
      }
    };

    checkAndLoad();

    window.addEventListener('CookiebotOnLoad', checkAndLoad);
    window.addEventListener('CookiebotOnAccept', checkAndLoad);

    return () => {
      window.removeEventListener('CookiebotOnLoad', checkAndLoad);
      window.removeEventListener('CookiebotOnAccept', checkAndLoad);
    };
  }, []);

  useEffect(() => {
    if (!shouldLoad) {
      return;
    }

    const portalId = clientConfig.hubspotPortalId;

    if (!portalId) {
      console.warn('HubSpot Portal ID not configured');
      return;
    }

    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.id = 'hs-script-loader';
    script.async = true;
    script.defer = true;
    script.src = `//js.hs-scripts.com/${portalId}.js`;

    script.onload = () => {
      hubspot.setContentType('landing-page');
      hubspot.setPageProperty('source', 'loan-application');
    };

    document.body.appendChild(script);

    return () => {
      const existingScript = document.getElementById('hs-script-loader');
      if (existingScript) {
        document.body.removeChild(existingScript);
      }
    };
  }, [shouldLoad]);

  return null;
}
